import { render } from "./FundHistoryDeposit.vue?vue&type=template&id=d4877d36&scoped=true"
import script from "./FundHistoryDeposit.vue?vue&type=script&lang=js"
export * from "./FundHistoryDeposit.vue?vue&type=script&lang=js"

import "./FundHistoryDeposit.vue?vue&type=style&index=0&id=d4877d36&lang=less&scoped=true"
import "./FundHistoryDeposit.vue?vue&type=style&index=1&id=d4877d36&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4877d36"]])

export default __exports__